import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAppContext } from "../../classes/contexts/AppContext";
import { SidebarPosition } from "../../classes/enums/SideBarsEnum";
import "./SideBar.css";

const SideBar = ({
  alignment = SidebarPosition.LEFT,
  isCollapsible = true,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const location = useLocation();
  const {
    leftSidebarWidth,
    rightSidebarWidth,
    leftWidgetComponent,
    rightWidgetComponent,
  } = useAppContext();
  const sidebarRef = useRef(null);

  const sidebarWidth =
    alignment === SidebarPosition.LEFT ? leftSidebarWidth : rightSidebarWidth;

  let children;
  if (alignment === SidebarPosition.LEFT) {
    children = leftWidgetComponent;
  } else if (alignment === SidebarPosition.RIGHT) {
    children = rightWidgetComponent;
  }

  useEffect(() => {
    if (isCollapsible) {
      const isSidebarExpanded =
        location.pathname.startsWith("/plan") ||
        location.pathname.startsWith("/patientDashboard");
      setIsCollapsed(!isSidebarExpanded);
      setIsContentVisible(isSidebarExpanded);
    } else {
      setIsCollapsed(false);
      setIsContentVisible(true);
    }
  }, [location.pathname, isCollapsible]);

  function toggleSideBar() {
    if (isCollapsible) {
      setIsCollapsed(prev => !prev);
      if (isCollapsed) {
        setTimeout(() => setIsContentVisible(true), 150);
      } else {
        setIsContentVisible(false);
      }
    }
  }

  return (
    <div
      ref={sidebarRef}
      className={`App-side-bar-container ${alignment} ${
        isCollapsed ? "collapsed" : ""
      }`}
    >
      <div className={`App-side-bar ${alignment} ${sidebarWidth}`}>
        <div className={`sidebar-content ${isContentVisible ? "" : "hidden"}`}>
          {children}
        </div>
      </div>
      {isCollapsible && (
        <div className="App-side-bar-tab" onClick={toggleSideBar}></div>
      )}
    </div>
  );
};

export default SideBar;
